// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1vY3_","label":"CategoryService_label__1l8mx","location":"CategoryService_location__1b7Zp"};